import styled from 'styled-components';
import { navBarHeight, Format, StyleColor, blurredBackgroundColor, BaseStyledComponentProps } from '../../utils/styles-constants';
import { PageType } from '../../containers/Page/constants';

interface StyledPageProps extends BaseStyledComponentProps {
	pageType: PageType;
	backgroundUrl: string;
	backgroundColor: string;
	isVideoBackground: boolean;
	isScrollable?: boolean;
}

const PageWrapper = styled('div')`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor};
	padding-top: ${navBarHeight};
	background: ${({ pageType, isVideoBackground, backgroundColor, theme }: StyledPageProps) => pageType === PageType.DrivePage && isVideoBackground
		? 'none'
		: (backgroundColor || theme.primary.backgroundColor)};

	${({ pageType, backgroundUrl, isVideoBackground }: StyledPageProps) => pageType === PageType.DrivePage && backgroundUrl && !isVideoBackground &&
		`background: url(${backgroundUrl});
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;`
	}

	${(props: StyledPageProps) => props.isScrollable &&
		`-webkit-overflow-scrolling: touch;
		overflow-y: auto;
		overflow-x: hidden;`
	}

	${(props: StyledPageProps) =>
		[
			PageType.NotFoundPage,
			PageType.ParametersPage,
			PageType.ProfilePage,
			PageType.ProposalStatsPage,
			PageType.NotesPage,
		].includes(props.pageType) &&
		`padding: ${navBarHeight} 50px 50px;

		@media ${Format.Smartphone} {
			padding: ${navBarHeight} 25px 10px;
		}`
	}

	${(props: StyledPageProps) => props.pageType === PageType.StaticPage &&
		`padding: ${navBarHeight} 0 0;`
	}

	${(props: StyledPageProps) =>
		[
			PageType.ProposalStatsPage,
			PageType.NotesPage,
		].includes(props.pageType) &&
		`display: flex;
			flex-direction: column;
			overflow-y: hidden;
			padding-bottom: 0;

			@media ${Format.Smartphone} {
				padding-bottom: 0;
			}`
	}

	@media print {
		color: #000;
		background: #fff;
	}
`;

const TitleWrapper = styled('div')`
	padding-top: 20px;
	padding-bottom: 15px;

	@media ${Format.Smartphone}, ${Format.SmartphoneLandscape} {
		padding-top: 15px;
	}
`;

const BottomBarHeight = '60px';
const bottomBarColor = StyleColor.Grey700;

const StyledBottomBar = styled('div')`
	backdrop-filter: blur(10px);
	height: ${BottomBarHeight};
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
`;

const BottomBarBackground = styled('div')`
	height: 100%;
	background-color: ${blurredBackgroundColor};
	display: flex;
	align-items: center;
	justify-content: space-around;
`;

const VideoBackground = styled('video')`
	position: absolute;
	z-index: -1;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: auto;
	height: auto;
	min-width: 100%;
	min-height: 100%;
	pointer-events: none;
	object-fit: cover;

	@media print {
		display: none;
	}
`;

export { PageWrapper, TitleWrapper, StyledPageProps, StyledBottomBar, BottomBarBackground, BottomBarHeight, bottomBarColor, VideoBackground };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Page/styles.ts